<template>
  <v-card data-testid="regimen_header_edit">
    <v-card-text>
      <v-container>
        <v-text-field
          v-model="localValue.title"
          :label="$t('common.title')"
          type="text"
          data-testid="regimen_header_edit_title"
        />

        <p>{{ $t("common.instructions") }}</p>
        <QuillEditor v-model="localValue.instructions" :placeholder="$t('common.instructions')" style="height: 200px; margin-bottom: 20px" />
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click="save" data-testid="regimen_header_edit_save">{{ $t("common.save") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import QuillEditor from "./QuillEditor";

export default {
  components: { QuillEditor },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    let data = {};
    return data;
  },
  computed: {
    localValue: {
      get() {
        let value = this.value;
        value.default = value.default || {};
        return value;
      },
      set(localValue) {
        if (!localValue.default) {
          localValue.default = {};
        }
        this.$emit("input", localValue);
      },
    },
  },
  mounted() {},
  methods: {
    save() {
      this.$emit("save");
    },
  },
};
</script>

<style>
#invite_edit_modal .v-messages__message {
  line-height: normal;
}

.ql-editor {
  font-size: large;
}

.theme--dark .ql-snow .ql-stroke {
  stroke: gray;
}

.theme--light .ql-editor p {
  color: black;
}

/* RTL languages */
html[lang="he"] .ql-editor,
html[lang="ar"] .ql-editor {
  text-align: right;
}
</style>
